// =============================================================================
// Updated FloatingActionButtons.jsx - Cone search button above search panel
import React from 'react';

const FloatingActionButtons = ({
  isAladinReady,
  showSearch,
  setShowSearch,
  showConeSearch,
  setShowConeSearch
}) => {
  return (
    <>
      {/* Main floating button in top-right for search toggle */}
      <div className="absolute top-20 right-6 z-10 flex flex-col space-y-3">
        {!showSearch && (
          <button
            onClick={() => setShowSearch(true)}
            className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 shadow-lg transition-colors"
            disabled={!isAladinReady}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <span>Search</span>
          </button>
        )}
      </div>

      {/* Cone Search button positioned above search panel */}
      {showSearch && (
        <div className="absolute bottom-48 left-8 z-50">
          <button
            onClick={() => setShowConeSearch(!showConeSearch)}
            className={`flex items-center space-x-2 px-3 py-2 text-sm font-medium rounded-md shadow-lg transition-all duration-200 border ${
              showConeSearch 
                ? 'text-white bg-primary-600 hover:bg-primary-700 border-red-500' 
                : 'text-ui-light-text-primary dark:text-ui-dark-text-primary bg-ui-light-card/90 dark:bg-ui-dark-card/90 hover:bg-ui-light-hover/90 dark:hover:bg-ui-dark-hover/90 border-red-400 dark:border-red-500 backdrop-blur-sm'
            }`}
            disabled={!isAladinReady}
            style={{ borderWidth: '1px' }}
          >
            <div className="w-4 h-4">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
                <circle cx="11" cy="11" r="3"></circle>
              </svg>
            </div>
            <span>Cone Search {showConeSearch ? '(Active)' : ''}</span>
          </button>
        </div>
      )}
    </>
  );
};

export default FloatingActionButtons;